import styled from '@emotion/styled';

export const CompressedCalculatePriceCard = styled.div`
  position: relative;
  background-color: ${({ theme }): string => theme.WHITE};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 11px 0px 20px 8px;
  margin-bottom: 10px;
`;

export const Message = styled.div`
  background-color: ${({ theme }): string => theme.GREY_1};
  font-size: 12px;
  font-family: Inter;
  padding: 10px;
  width: 100%;
  margin-bottom: 14px;
  margin-right: 10px;
  border-radius: 10px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  margin-right: 60px;
  svg {
    margin-right: 10px;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const ItemTitle = styled.p`
  font-size: 12px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const ItemValue = styled.p`
  font-size: 14px;
  font-weight: 600;
`;

export const Spacer = styled.div`
  border-left: 1px solid ${({ theme }): string => theme.GREY_5};
  margin: 4px 60px 4px 0px;
`;

export const CloseButton = styled.button`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme }): string => theme.PRIMARY};

  margin-left: auto;
  margin-right: 24px;

  &:hover {
    text-decoration: underline;
  }
`;
